export const CoreTagsByIdName = 'CoreTagsById';
